// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"e654d432","393":"dc1cd217","814":"fa0a7014"}[chunkId] + ".chunk.css";
};